import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { quickOrderProductListStyles } from "@dana/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

quickOrderProductListStyles.cardContainer = mergeToNew(quickOrderProductListStyles.cardContainer, {
    cardDivider: {
        css: css`
            border-bottom: none;
            > div {
                padding-left: 0;
                padding-right: 0;
            }
        `,
    },
});

quickOrderProductListStyles.gridContainer = mergeToNew(quickOrderProductListStyles.gridContainer, {
    gap: 20,
});

quickOrderProductListStyles.brandAndProductDescriptionGridItem = mergeToNew(quickOrderProductListStyles.brandAndProductDescriptionGridItem, {
    width: [12, 12, 12, 4, 4],
});

quickOrderProductListStyles.priceAndQuantityGridItem = mergeToNew(quickOrderProductListStyles.priceAndQuantityGridItem, {
   width: [12, 12, 12, 8, 8]
});

quickOrderProductListStyles.productImageGridItem= mergeToNew(quickOrderProductListStyles.productImageGridItem, {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                css`
                    max-width: 100px;
                    flex-basis: 100px;
                `,
            ],
            "min",
        )}
        &[class*="GridItemStyle"] {
            padding-left: 10px;
        }
    `,
});

quickOrderProductListStyles.productImage = mergeToNew(quickOrderProductListStyles.productImage, {
    img: {
        css: css`
            max-width: 100px;
        `,
    },
});

quickOrderProductListStyles.productInfoContainer = mergeToNew(quickOrderProductListStyles.productInfoContainer, {
    gap: 20,
});

quickOrderProductListStyles.priceAndQuantityContainer = mergeToNew(
    quickOrderProductListStyles.priceAndQuantityContainer,
    {
        gap: 20,
    },
);

quickOrderProductListStyles.productNumberText = mergeToNew(quickOrderProductListStyles.productNumberText, {
    weight: fontWeights.semiBold,
    css: css`
        margin-bottom: 4px;
    `,
});

quickOrderProductListStyles.quantityGridItem = mergeToNew(quickOrderProductListStyles.quantityGridItem, {
   width: [12, 12, 5, 5, 4],
    css: css`
        .qo-list-item {
            gap: 8px;
            flex-wrap: wrap;

            > [class*="FormFieldStyle"] {
                width: auto;
                flex-direction: column;
            }
            [class*="FormFieldLabel"]  {
                padding-top: 0;
                display: flex;
                align-items: center;
                margin-top: -4px;
                & + [class*="FormInputWrapper"] {
                    margin: 0;
                }
            }
        }
        .pricing-subtext {
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.small};
        }
    `,
});

quickOrderProductListStyles.priceGridItem = mergeToNew(quickOrderProductListStyles.priceGridItem, {
    css: css`
        justify-content: flex-start;
    `
});
quickOrderProductListStyles.extendedPriceGridItem = mergeToNew(quickOrderProductListStyles.extendedPriceGridItem, {
    width: [12, 12, 3, 3, 4],
    css: css`
        justify-content: flex-start;
        align-self: flex-start;
    `
});

quickOrderProductListStyles.addToListLink = mergeToNew(quickOrderProductListStyles.addToListLink, {
    link: {
        css: css`
            &.btn-tertiary_small {
                border-color: transparent;
            }
        `,
    },
});

quickOrderProductListStyles.removeProductGridItem = mergeToNew(quickOrderProductListStyles.removeProductGridItem, {
    css: css`
        &[class*="GridItemStyle"] {
            margin-left: auto !important;
        }
    `
});
